export default "<p>about-details works!</p>\n"